import { Flex, FlexProps, Spinner, Text } from '@chakra-ui/react';

interface Props extends FlexProps {
  year: string;
  make: string;
  model: string;
  vin: string;
  infoLoading: boolean;
  hideVin?: boolean;
}

const VehicleInfo = ({ year, make, model, vin, infoLoading, hideVin = false, ...rest }: Props) => {
  return (
    <Flex
      direction="column"
      w="full"
      p={5}
      borderRadius={5}
      bgColor="brightGray"
      alignItems="center"
      justifyContent="center"
      gap={3}
      {...rest}
    >
      {infoLoading ? (
        <Spinner size="sm" />
      ) : (
        <Flex alignItems="center" mb={1}>
          <Text fontSize="2xl" as="b" mr={2}>
            {`${year} ${make}`} {model}
          </Text>
        </Flex>
      )}
      {!hideVin && (
        <Text as="b" pr={1} fontSize="14px">
          VIN: {infoLoading ? <Spinner size="xs" /> : vin}
        </Text>
      )}
    </Flex>
  );
};

export default VehicleInfo;
